import { render, staticRenderFns } from "./FieldGroup.vue?vue&type=template&id=28c75bdf&scoped=true&"
import script from "./FieldGroup.vue?vue&type=script&lang=js&"
export * from "./FieldGroup.vue?vue&type=script&lang=js&"
import style0 from "./FieldGroup.vue?vue&type=style&index=0&id=28c75bdf&prod&lang=scss&scoped=true&"
import style1 from "./FieldGroup.vue?vue&type=style&index=1&id=28c75bdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c75bdf",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QIcon,QTooltip,QItem,QPopupEdit,QInput,QCardSection,QList,QToggle,QBtn,QSelect,QColor});
